<a href="javascript:;">
  <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span>
</a>
